import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
} from '@mui/material';
import { formatFileSize } from '../../utils/fileUtils'; // Import the utility

// Helper to render nested properties
const renderProperties = (properties) => {
  if (!properties || typeof properties !== 'object') {
    return <Typography variant="body2">No properties available.</Typography>;
  }

  return Object.entries(properties).map(([key, value]) => {
    const formattedKey = key.replace(/_/g, ' '); // Format key

    if (key === 'inference_result' && typeof value === 'object' && value !== null) {
      // Special handling for inference_result
      return (
        <ListItem key={key} disableGutters sx={{ display: 'block', pl: 2 }}>
          <Typography variant="body2" component="span" sx={{ fontWeight: 'bold', textTransform: 'capitalize' }}>
            {formattedKey}:
          </Typography>
          <List dense disablePadding sx={{ pl: 2 }}>
            {Object.entries(value).map(([infKey, infValue]) => (
              <ListItem key={infKey} disableGutters sx={{ py: 0 }}>
                <ListItemText
                  primary={`- ${infKey.replace(/_/g, ' ')}:`}
                  secondary={Array.isArray(infValue) ? infValue.join(', ') : (typeof infValue === 'string' ? infValue : JSON.stringify(infValue))}
                  primaryTypographyProps={{ variant: 'body2', sx: { fontWeight: 'bold', textTransform: 'capitalize' } }}
                  secondaryTypographyProps={{ variant: 'body2', sx: { ml: 0.5 } }}
                />
              </ListItem>
            ))}
          </List>
        </ListItem>
      );
    } else {
      // Default rendering for other properties
      return (
        <ListItem key={key} disableGutters sx={{ py: 0, pl: 2 }}>
          <ListItemText
            primary={`- ${formattedKey}:`}
            secondary={Array.isArray(value) ? value.join(', ') : (typeof value === 'string' ? value : JSON.stringify(value))}
            primaryTypographyProps={{ variant: 'body2', sx: { fontWeight: 'bold', textTransform: 'capitalize' } }}
            secondaryTypographyProps={{ variant: 'body2', sx: { ml: 0.5 } }}
          />
        </ListItem>
      );
    }
  });
};

const DocumentDetailsCollapse = ({ doc }) => {
  return (
    <Box
      sx={{
        pl: 9, // Matches indentation
        pr: 2,
        py: 2,
        borderBottom: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper', // Optional: gives slight contrast
      }}
    >
      <Typography variant="body2" gutterBottom>
        <strong>Name:</strong> {doc.name}
      </Typography>
      <Typography variant="body2" gutterBottom>
        <strong>Size:</strong> {formatFileSize(doc.size) || 'N/A'}
      </Typography>
      <Typography variant="body2" gutterBottom>
        <strong>Status:</strong> {doc.status || 'N/A'}
        {doc.status === 'PROCESSING' && <CircularProgress size={12} sx={{ ml: 1 }} />}
      </Typography>
      {doc.status === 'ERROR' && (
        <Typography variant="body2" color="error" gutterBottom>
          <strong>Error:</strong> {doc.parsedProperties?.error_message || 'Processing failed.'}
        </Typography>
      )}
      <Typography variant="body2" gutterBottom>
        <strong>Properties:</strong>
      </Typography>
      <List dense disablePadding>
        {renderProperties(doc.parsedProperties)}
      </List>
    </Box>
  );
};

export default DocumentDetailsCollapse;
